import React from "react";
import { classNames } from "src/common_util";
import { StreamlineIcon } from "src/components/icons";
import loadingSpinnerAnimatedIconUrl from "images/icons/loading-spinner-animated.svg";

const SubmitButton = ({
  buttonCopy,
  isPrimary,
  enabled,
  isLoading = false,
  onSubmit,
  hasBottomSpacing,
  dataTestId,
}: {
  buttonCopy: string;
  isPrimary: boolean;
  enabled: boolean;
  isLoading?: boolean;
  onSubmit: () => Promise<void>;
  hasBottomSpacing: boolean;
  dataTestId?: string;
}) => {
  const classes = classNames({
    "button space-mr-sm": true,
    "is-primary": isPrimary,
    "is-visually-disabled": !enabled,
    "space-mb-sm": hasBottomSpacing,
    "is-loading": isLoading,
  });

  return (
    <button
      name="button"
      type="submit"
      className={classes}
      disabled={!enabled}
      data-testid={dataTestId}
      data-cy="place-order-button"
      onClick={onSubmit}
    >
      <span className="loading-icon show-while-loading">
        <StreamlineIcon href={loadingSpinnerAnimatedIconUrl} />
      </span>

      <span className="hide-while-loading">
        {buttonCopy}
      </span>
    </button>
  );
};

export { SubmitButton };
